import { $Q, $Qll } from '../utils/query-selector';

const initCustomCursor = () => {
  // Ensure the custom cursor only applies to desktop screens
  if (window.innerWidth <= 900) return;

  // Check if the custom cursor already exists
  let customCursor = $Q('.custom-cursor');
  if (!customCursor) {
    // Create the custom cursor element and append it to the body
    customCursor = document.createElement('div');
    customCursor.className = 'custom-cursor';
    document.body.appendChild(customCursor);
  }

  // Make the cursor visible and follow the mouse movements
  document.addEventListener('mousemove', (e) => {
    const cursorX = e.pageX;
    const cursorY = e.pageY;

    customCursor.style.left = `${cursorX}px`;
    customCursor.style.top = `${cursorY}px`;

    customCursor.classList.add('visible');
  });

  // Add a "click" effect to the custom cursor
  document.addEventListener('click', () => {
    customCursor.classList.add('expand');
    setTimeout(() => {
      customCursor.classList.remove('expand');
    }, 500);
  });

  // Detect hover on interactive elements (links and buttons)
  const interactiveElements = $Qll('a, button');
  interactiveElements.forEach((el) => {
    el.addEventListener('mouseover', () => customCursor.classList.add('hover'));
    el.addEventListener('mouseout', () => customCursor.classList.remove('hover'));
  });
};

export default initCustomCursor;
